import { conConfig } from "@victorequena22/conneccion"
import { toast } from "react-toastify"
export const getStatus = async (url: string, id: string | number, data: any, update: () => void) => {
    conConfig('').post(`/api/Programa/Suscribirse/status/${url}/${id}`, data,
        () => { update(); toast('GUARDADO EXITOSAMENTE', { type: toast.TYPE.SUCCESS }) },
        () => { update(); toast('ERROR', { type: toast.TYPE.ERROR }) })
}